import { useEffect } from 'react';

// Extract subscription cards from the outer container on the Membership tab to make it full width
export const useMembershipTabContainer = ({
  isMobile,
}: {
  isMobile: boolean;
}) => {
  useEffect(() => {
    const container = $('#sign_up > div');
    const profileTabs = container.find('.profile-tabs');
    const membershipTab = container.find('.membership-tab');
    const billingFrequency = container.find('.billing-frequency');

    let profileTabsOffset;

    const handleSubscriptionCardsFullWidth = () => {
      container.removeClass('container max-w-1440px');
      profileTabs.addClass('container max-w-1440px');
      billingFrequency.addClass('container max-w-1440px');

      profileTabsOffset = $('.profile-tabs > ul > li').offset()!.left;

      membershipTab.css({
        'margin-left': `${profileTabsOffset}px`,
        'margin-right': '0px',
      });
    };

    if (isMobile) {
      membershipTab.addClass('container mx-auto');
    } else {
      handleSubscriptionCardsFullWidth();
      window.addEventListener('resize', handleSubscriptionCardsFullWidth);
    }

    return () => {
      container.addClass('container max-w-1440px');
      profileTabs.removeClass('container max-w-1440px');
      billingFrequency.removeClass('container max-w-1440px');
      profileTabs.find('ul').removeClass('px-6');
      membershipTab.css('margin-right', 'auto');

      window.removeEventListener('resize', handleSubscriptionCardsFullWidth);
    };
  }, [isMobile]);
};
